import { useMemo } from 'react';
import { classNames, filterProps, flatten } from '../utils';
export var useClassNames = function (globalStyles, otherStyles) {
    if (globalStyles === void 0) { globalStyles = {}; }
    if (otherStyles === void 0) { otherStyles = []; }
    var styles = useMemo(function () { return filterProps(globalStyles); }, [globalStyles]);
    var flattenedStyles = useMemo(function () { return classNames(flatten([otherStyles.filter(Boolean), styles])); }, [otherStyles, styles]);
    return flattenedStyles;
};
//# sourceMappingURL=use-class-names.js.map